const init = () => {
  headerNav();
  footerNav();
  contact();
};

const headerNav = () => {
  const header = document.querySelector(".js-header");
  const headerDesktopItems = document.querySelectorAll(".js-header-link");
  const headerMenuModal = document.querySelector(".js-header-nav-modal");
  const headerMobileNav = document.querySelector(".js-header-nav-mobile");

  const hideMenu = () => {
    header.classList.remove("active");
    headerMenuModal.classList.remove("active");
    headerMobileNav.classList.remove("active");
    document.querySelector(".js-header-nav").classList.remove("active");
  };

  if (headerDesktopItems && headerDesktopItems.length) {
    headerDesktopItems.forEach((item) => {
      item.addEventListener("mouseover", (event) => {
        event.preventDefault();
        if (!headerMobileNav.classList.contains("active")) {
          item.classList.add("active");
          headerMenuModal.classList.add("active");
          header.classList.add("active");
        }
      });

      item.addEventListener("mouseout", (event) => {
        event.preventDefault();
        if (!headerMobileNav.classList.contains("active")) {
          item.classList.remove("active");
          headerMenuModal.classList.remove("active");
          header.classList.remove("active");
        }
      });

      item.addEventListener("click", () => {
        if (headerMobileNav.classList.contains("active")) {
          const activeHeaderLink = document.querySelector(
            ".js-header-link.active"
          );
          if (activeHeaderLink && item != activeHeaderLink) activeHeaderLink.classList.remove("active");

          item.classList.toggle("active");
        }
      });
    });
  }

  if (headerMobileNav) {
    headerMobileNav.addEventListener("click", (event) => {
      event.preventDefault();
      headerMenuModal.classList.toggle("active");
      headerMobileNav.classList.toggle("active");
      header.classList.toggle("active");
      document.querySelector(".js-header-nav").classList.toggle("active");
    });

    headerMenuModal.addEventListener("click", (event) => {
      event.preventDefault();
      hideMenu();
    });
  }
};

const footerNav = () => {
  const footerItems = document.querySelectorAll(".js-footer-mobile");

  if (footerItems && footerItems.length) {
    footerItems.forEach((item) =>
      item.addEventListener("click", () => {
        item.classList.toggle("active");
      })
    );
  }
};

const contact = () => {
  const contactModal = document.querySelector(".js-contact");
  const contactClose = document.querySelector(".js-contact-close");

  contactClose.addEventListener("click", (event) => {
    event.preventDefault();
    contactModal.classList.remove("active");
    window.location.hash = "";
  });

  const contactOpen = document.querySelectorAll(".js-contact-open");

  if (contactOpen.length) {
    contactOpen.forEach((item) =>
      item.addEventListener("click", (event) => {
        event.preventDefault();
        contactModal.classList.add("active");
      })
    );
  }

  window.onhashchange = (event) => {
    if (window.location.hash === "#contact-form") {
      event.preventDefault();
      contactModal.classList.add("active");
    }
  };

  if (window.location.hash === "#contact-form") {
    contactModal.classList.add("active");
  }
};

if (document.readyState !== "loading") {
  init();
} else {
  document.addEventListener("DOMContentLoaded", init);
}
